import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

import {
  FULL_APP_BAR_MIN_WIDTH,
  GET_UPDATES_LABEL_MIN_WIDTH,
} from "~/components/AppBar/AppBar.styles";

export const Label = styled("span")(({ theme }) => ({
  [theme.breakpoints.down(GET_UPDATES_LABEL_MIN_WIDTH)]: {
    display: "none",
  },
}));

export const TriggerButton = styled(Button)(({ theme }) => {
  const isDark = theme.palette.mode === "dark";

  return {
    flexShrink: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: 999,
    textTransform: "none",
    fontWeight: 600,
    whiteSpace: "nowrap",
    boxShadow: "none",
    backgroundColor: isDark ? theme.palette.common.white : "#111111",
    color: isDark ? "#111111" : theme.palette.common.white,

    "&:hover": {
      boxShadow: "none",
      backgroundColor: isDark ? theme.palette.grey[300] : "#2A2E35",
    },

    "& .MuiButton-startIcon svg": {
      width: 16,
      height: 16,
    },

    [theme.breakpoints.down(FULL_APP_BAR_MIN_WIDTH)]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },

    [theme.breakpoints.down(GET_UPDATES_LABEL_MIN_WIDTH)]: {
      minWidth: 0,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),

      "& .MuiButton-startIcon": {
        margin: 0,
      },
    },
  };
});
